export default "__VITE_ASSET__C_yCFJLL__"